import { render, staticRenderFns } from "./Circuiti.vue?vue&type=template&id=c9c7d232"
import script from "./Circuiti.vue?vue&type=script&lang=js"
export * from "./Circuiti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports